<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <div class="columns" v-show="showList">
        <div class="column">
          <section class="hero is-info" v-show="showList">
            <div class="hero-body">
              <div class="container">
                <h1 class="title is-4">
                  รายการรถ {{ stepCurrent.title }}
                </h1>
                <h2 class="subtitle is-6">
                  สาขา {{ branchSelected }}
                </h2>
              </div>
            </div>
            <article class="message" v-show="!dataAlready[current_step]">
              <div class="message-body">กำลังดึงข้อมูล...</div>
            </article>
            <table class="table" style="width:100%" v-show="dataAlready[current_step]">
            <thead>
              <tr>
                <th><abbr title="runNo">ลำดับที่</abbr></th>
                <th><abbr title="licenseNo">ทะเบียน</abbr></th>
                <th><abbr title="startTime">เวลา</abbr></th>
                <th><abbr title="startTime">คาดว่า<br>จะเสร็จ</abbr></th>
                <th><abbr title="action"></abbr></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="car in carList[current_step]" v-bind:key="car.id" v-bind:class="{ customerWait: car.customerWait }">
                <td>
                  <span class="error" v-if="(car.userId === -1)">*</span>
                  {{car.runNo}} <span v-if="car.customerWait">(รอรับ)</span>
                </td>
                <td>{{car.licenseNo}}</td>
                <td>{{car.updateTime}}</td>
                <td>{{car.expectedTime}}<br>{{car.expectedDate}}</td>
                <td>
                  <div v-if="current_step === 'queue_repair'" class="buttons are-small">
                    <button  v-for="btn in stepCurrent.nextstep" v-bind:key="btn.action" class="button is-info" v-on:click="openSelectTechnician($event, car.id, car.licenseNo, car.runNo)" >{{ btn.title }}</button>
                  </div>
                  <div v-else-if="current_step === 'final_inspec'" class="buttons are-small">
                    <button  v-for="btn in stepCurrent.nextstep" v-bind:key="btn.action" class="button is-info" v-on:click="openSelectLeader($event, car.id, car.licenseNo, car.runNo, btn.action)" >{{ btn.title }}</button>
                  </div>
                  <div v-else-if="current_step === 'cleaning'" class="buttons are-small">
                    <button  v-for="btn in stepCurrent.nextstep" v-bind:key="btn.action" class="button is-info" v-on:click="openInputCost($event, car.id, car.licenseNo, car.runNo)" >{{ btn.title }}</button>
                  </div>
                  <div v-else class="buttons are-small">
                    <button  v-for="btn in stepCurrent.nextstep" v-bind:key="btn.action" class="button is-info" v-on:click="updateProgress($event, car.id, '', btn.action)" >{{ btn.title }}</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </section>
        </div>
        <div class="column" v-show="showComplete">
          <section class="hero is-info">
            <div class="hero-body">
              <div class="container">
                <h1 class="title is-4">
                  รายการส่งมอบรถ {{ stepCurrent.name }}
                </h1>
                <h2 class="subtitle is-6">
                  สาขา {{ branchSelected }}
                </h2>
              </div>
            </div>
            <article class="message" v-show="!dataAlready['complete']">
              <div class="message-body">กำลังดึงข้อมูล...</div>
            </article>
            <table class="table" style="width:100%" v-show="dataAlready['complete']">
            <thead>
              <tr>
                <th><abbr title="runNo">ลำดับที่</abbr></th>
                <th><abbr title="licenseNo">ทะเบียน</abbr></th>
                <th><abbr title="startTime">เวลาเริ่มต้น</abbr></th>
                <th><abbr title="action">ค่าใช้จ่าย</abbr></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="car in carList.complete" v-bind:key="car.id">
                <td>
                  <span class="error" v-if="(car.userId === -1)">*</span>
                  {{car.runNo}}
                </td>
                <td>{{car.licenseNo}}</td>
                <td>{{car.updateTime}}</td>
                <td align="right">{{car.cost_total}}</td>
              </tr>
            </tbody>
          </table>
          </section>
        </div>
    </div>
    <section class="section" v-show="selectTechnician">
      <div class="container">
        <h2 class="title is-4">กรุณาเลือกช่าง<br>สำหรับงาน {{ carInfo.runNo }} <br>ทะเบียน {{ carInfo.licenseNo }}</h2>
        <h3 class="">
          <div class="select">
            <select v-model="staffId">
              <option v-for="staff in staffList" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
            </select>
          </div>
          <div class="select">
            <select v-model="staffId_2">
              <option v-for="staff in staffList" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
            </select>
          </div>
          <br><br>
          <div class=" are-medium" style="text-align:center">
            <button class="button is-info" v-on:click="updateProgress($event, carId, 'queue_repair', 'repair')" >{{ btn_confirm_title }}</button>
          </div>
        </h3>
      </div>
    </section>

    <section class="section" v-show="selectLeader">
      <div class="container">
        <h2 class="title is-4">กรุณาเลือกผู้ตรวจสอบ<br>สำหรับงาน {{ carInfo.runNo }} <br>ทะเบียน {{ carInfo.licenseNo }}</h2>
        <h3 class="">
          <div class="select">
            <select v-model="leaderId">
              <option v-for="staff in staffList" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
            </select>
          </div><br><br>
          <div class=" are-medium" style="text-align:center">
            <button class="button is-info" v-on:click="updateProgress($event, carId, 'final_inspec', action_select)" >{{ btn_confirm_title }}</button>
          </div>
        </h3>
      </div>
    </section>

    <section class="section" v-show="inputCost">
      <div class="container">
        <h2 class="title is-5">กรุณากรอกค่าใช้จ่าย<br>สำหรับงาน {{ carInfo.runNo }} <br>ทะเบียน {{ carInfo.licenseNo }}</h2>
        <h3 class="">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">ราคา IDS (ราคารวม VAT)</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" placeholder="0" v-model="cost_ids" v-on:change="cal_cost_total">
                </p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">ราคา System Pro (ราคารวม VAT)</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" placeholder="0" v-model="cost_system_pro" v-on:change="cal_cost_total">
                </p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">ราคารวม (รวม VAT)</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" placeholder="0" v-model="cost_total" disabled>
                </p>
              </div>
            </div>
          </div>
          <div class=" are-medium" style="text-align:center">
            <button class="button is-info" v-on:click="updateProgress($event, carId, 'cleaning', 'complete')" >{{ btn_confirm_title }}</button>
          </div>
        </h3>
      </div>
    </section>
    <span class="error">{{ error_msg }}</span>

  </div>
</template>
<style>
.column {
  padding: 0rem .5rem !important;
}
.customerWait {
  color: #fd1880;
  background-color: #ffe9f3;
}
.banner {
  text-align: center;
  background-color: #000;
}
.error {
  color: red;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Progress',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    } else {
      // this.$liff.init({ liffId: this.$liffId_Service_Progress }, function (data) {})
    }
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    size: 200,
    showComplete: false,
    dataAlready: {
      'queue_repair': false,
      'repair': false,
      'final_inspec': false,
      'cleaning': false,
      'complete': false
    },
    confirmSuccess: false,
    showList: true,
    selectTechnician: false,
    selectLeader: false,
    inputCost: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    step: [
      {
        current: 'start',
        title: 'รับรถเข้าบริการ',
        nextstep: [{
          title: 'ส่งคิวซ่อม',
          action: 'queue_repair'
        }]
      },
      {
        current: 'queue_repair',
        title: 'รอคิวซ่อม',
        nextstep: [{
          title: 'ส่งซ่อม',
          action: 'repair'
        }]
      },
      {
        current: 'repair',
        title: 'กำลังซ่อม',
        nextstep: [{
          title: 'ส่งตรวจสอบ',
          action: 'final_inspec'
        }]
      },
      {
        current: 'final_inspec',
        title: 'รอตรวจสอบขั้นสุดท้าย',
        nextstep: [{
          title: 'ผ่าน',
          action: 'cleaning'
        },
        {
          title: 'แจ้งเพิ่มเติม',
          action: 'repair'
        }]
      },
      {
        current: 'cost_summary',
        title: 'รอสรุปค่าใช้จ่าย',
        nextstep: [{
          title: 'สรุปเสร็จแล้ว',
          action: 'cleaning'
        }]
      }, {
        current: 'cleaning',
        title: 'กำลังทำความสะอาด',
        nextstep: [{
          title: 'ส่งมอบรถ',
          action: 'complete'
        }]
      }
    ],
    stepCurrent: {},
    branchSelected: '',
    branchCode: '',
    carInfo: {
      runNo: '',
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: '',
      expectedDate: '',
      expectedTime: '',
      customerWait: false
    },
    carId: '',
    carList: {
      'queue_repair': [],
      'repair': [],
      'repair_extra': [],
      'final_inspec': [],
      'final_inspec_extra': [],
      'cleaning': [],
      'complete': []
    },
    staffList: [],
    current_step: '',
    staffId: '',
    staffId_2: '',
    leaderId: '',
    btn_confirm_title: 'ยืนยัน',
    action_select: '',
    cost_total: '',
    cost_ids: '',
    cost_system_pro: '',
    error_msg: '',
    t: null,
    updatedBy: ''
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    _this.branch = this.$branchList
    // _this.getProfile()
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    _this.current_step = params.get('step')
    _this.branchCode = params.get('branchCode')
    const branchSelected = _this.branch.find((item) => item.id === _this.branchCode)
    _this.branchSelected = branchSelected ? branchSelected.name : ''
    _this.stepCurrent = _this.step.find((item) => item.current === _this.current_step)
    _this.getCarList(_this.current_step)
    if (_this.current_step === 'cleaning') {
      _this.getCarList('complete')
      _this.showComplete = true
    }
    if (_this.current_step === 'queue_repair') {
      _this.getTechnician()
    } else if (_this.current_step === 'final_inspec') {
      _this.getLeader()
    }
    _this.autoReload()
  },
  methods: {
    autoReload () {
      let _this = this
      _this.t = setInterval(() => {
        _this.getCarList(_this.current_step)
        if (_this.current_step === 'cleaning') {
          _this.getCarList('complete')
        }
      }, 120 * 1000)
    },
    stopReload () {
      clearInterval(this.t)
    },
    getCarList (step) {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getCarProgress?current=${step}&branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready[step] = true
          _this.carList[step] = response.data
          _this.selectTechnician = false
          _this.selectLeader = false
          _this.inputCost = false
          _this.showList = true
          _this.cost_total = ''
          _this.cost_ids = ''
          _this.cost_system_pro = ''
          _this.btn_confirm_title = 'ยืนยัน'
          _this.staffId = ''
          _this.error_msg = ''
        })
    },
    getTechnician () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=Technician`)
        .then(response => {
          _this.dataAlready = true
          _this.staffList = response.data
        })
    },
    getLeader () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=Technician Leader`)
        .then(response => {
          _this.dataAlready = true
          _this.staffList = response.data
        })
    },
    openSelectTechnician (event, carId, licenseNo, runNo) {
      this.stopReload()
      this.selectTechnician = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.runNo = runNo
    },
    openSelectLeader (event, carId, licenseNo, runNo, action) {
      this.stopReload()
      this.selectLeader = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.runNo = runNo
      this.action_select = action
    },
    openInputCost (event, carId, licenseNo, runNo) {
      this.stopReload()
      this.inputCost = true
      this.showList = false
      this.carId = carId
      this.carInfo.licenseNo = licenseNo
      this.carInfo.runNo = runNo
    },
    cal_cost_total () {
      this.cost_total = String(Number(this.cost_ids) + Number(this.cost_system_pro))
    },
    updateProgress (event, carId, currentStep, nextStep) {
      let _this = this
      if (nextStep === 'repair' && _this.staffId === '') {
        _this.error_msg = 'กรุณาระบุช่าง'
        return false
      } else if (nextStep === 'cleaning' && _this.leaderId === '') {
        _this.error_msg = 'กรุณาระบุผู้ตรวจสอบ'
        return false
      } else if (nextStep === 'repair_extra' && _this.leaderId === '') {
        _this.error_msg = 'กรุณาระบุผู้ตรวจสอบ'
        return false
      } else if (nextStep === 'complete' && (_this.cost_total === 0 || _this.cost_total === '')) {
        if (!confirm('รายการนี้ ไม่มีค่าใช้จ่ายใช่หรือไม่')) {
          return false
        } else {
          _this.cost_total = '0'
          _this.cost_ids = '0'
          _this.cost_system_pro = '0'
        }
      }
      _this.btn_confirm_title = 'กำลังดำเนินการ'
      _this.carId = carId
      let params = {
        carId: _this.carId,
        current: currentStep,
        nextStep: nextStep,
        staffId: _this.staffId,
        staffId_2: _this.staffId_2,
        leaderId: _this.leaderId,
        cost_system_pro: _this.cost_system_pro,
        cost_ids: _this.cost_ids,
        cost_total: _this.cost_total,
        updatedBy: _this.updatedBy
      }
      this.$axios
        .post(`${this.$apiUrl}updateProgress`, params)
        .then(response => {
          _this.updateSuccess = true
          _this.getCarList(_this.current_step)
          _this.getCarList('complete')
          _this.autoReload()
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Progress.vue